import { cn } from '@bw/core';
import { Block } from '../../factories/types';
import { annotate } from '../../utils/annotate';
import { schemeToClass } from '../../utils/colorMap';
import { RichText } from '../../utils/rich-text/RichText';
import { ButtonWrapper } from '../button/ButtonWrapper';
import styles from './InlineTextSection.module.scss';

export const InlineTextSection: Block<'inlineTextSection'> = ({ data }) => {
	const {
		fields: { title, text, button, colorScheme },
	} = data;

	return (
		<section
			className={cn(
				styles.inlineTextSection,
				!!title && !!text && !!button && styles.column,
				schemeToClass(colorScheme)
			)}
			{...annotate(data)}
		>
			{title ? (
				<div className={styles.title} {...annotate(data, 'title')}>
					<RichText document={title} />
				</div>
			) : null}

			{text ? (
				<div className={styles.text} {...annotate(data, 'text')}>
					<RichText document={text} />
				</div>
			) : null}

			{button ? <ButtonWrapper data={button} isPrimary /> : null}
		</section>
	);
};
